import {
  IonCol,
  IonIcon,
  IonLabel,
  IonPage,
  IonRow,
  IonText,
} from '@ionic/react';
import { chevronBackOutline, notificationsOutline } from 'ionicons/icons';

import styles from './Notifications.module.scss';

export default function Notifications() {
  return (
    <IonPage>
      <div className={styles.pageConfigNotifications}>
        <div className={styles.pageConfigNotificationsTitle}>
          <IonIcon
            md={chevronBackOutline}
            className={styles.pageConfigNotificationsTitleIcon}
          />
          <IonLabel className={styles.pageConfigNotificationsTitleText}>
            Configurar notificaciones
          </IonLabel>
        </div>
        <IonIcon
          md={notificationsOutline}
          className={styles.pageConfigNotificationsIcon}
        />
        <IonLabel className={styles.principalTitle}>Elige tus notificaciones</IonLabel>
        <IonText className={styles.principalText}>
          Escoge las notificaciones que quieres activar
        </IonText>
        <IonText className={styles.principalNotificationsPush}>
          Notificaciones push
        </IonText>
        <div>
          <IonRow>
            <IonCol>
              <IonLabel>Descuentos</IonLabel>
            </IonCol>
            <IonCol>-</IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <IonLabel>Ofertas</IonLabel>
            </IonCol>
            <IonCol>-</IonCol>
          </IonRow>
          <hr className={styles.separateLine} />
          <IonText className={styles.principalNotificationsPush}>
            Notificaciones de la app
          </IonText>
          <IonRow>
            <IonCol>
              <IonLabel>Descuentos</IonLabel>
            </IonCol>
            <IonCol>-</IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <IonLabel>Ofertas</IonLabel>
            </IonCol>
            <IonCol>-</IonCol>
          </IonRow>
        </div>
      </div>
    </IonPage>
  );
}
